<template>
  <v-card hover :to="'/debt/' + debt.orderNr" height="100%" class="debt-card">
    <v-card-title>
      <v-row no-gutters>
        <v-col cols="12" class="text-center">
          <h5 class="mt-0 mb-3 text-h5">{{ debt.creditor.name }}</h5>
          <p class="mb-0" v-if="debt.endDate !== null">
            <span v-if="debt.debtSummary.state.state === 8">{{ $t('ac-text-1') }} {{ debt.endDate | formatDate }}</span>
            <span v-else>{{ $t('ac-text-2') }} {{ debt.endDate | formatDate }}</span>
          </p>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>      
      <v-row no-gutters >
        <v-col cols="12" class="text-center">
          <v-icon size="150" :class="'py-5 font-weight-bold debt-state state-' + debt.debtSummary.state.colorGroup">
            fa-check
          </v-icon>
          <p class="mb-4 mt-2">
            {{ $t('paid') }}
            {{ debt.debtSummary.totalPaid | currency }} /
            {{ debt.debtSummary.total | currency }}
          </p>
          <p :class="'mb-2 text-uppercase font-weight-bold debt-state state-' + debt.debtSummary.state.colorGroup">
            {{ $t('state.' + debt.debtSummary.state.state) }}
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: ['debt']
  }
</script>

<i18n>
  {
  "fi": {
  "ac-text-1": "Maksupäivä:",
  "ac-text-2": "Lopetuspäivä:"
  },
  "se": {
  "ac-text-1": "Betalningsdag:",
  "ac-text-2": "Slutdatum:"
  },
  "en": {
  "ac-text-1": "Payment date:",
  "ac-text-2": "End date:"
  }
  }
</i18n>
